import { Injectable, inject } from '@angular/core';
import { HttpService } from '@boels/helpers';
import { Observable, switchMap } from 'rxjs';
import { BOProductSearchPage, ParamsModel } from '@boels/models';
import { ApiContextService } from '../../services/api-context/api-context.service';

@Injectable({
  providedIn: 'any',
})
export class ProductSearchGateway {
  private readonly httpService = inject(HttpService);
  private apiContextService = inject(ApiContextService);

  getProductSearchPageByCategoryId(
    categoryId: string,
    currentPage?: number,
    sortCode?: string,
    query?: string,
  ): Observable<BOProductSearchPage> {
    return this.apiContextService.getContext().pipe(
      switchMap(([baseSite, language, currency]) => {
        const queryParams: ParamsModel = [
          ['fields', 'FULL'],
          ['currentPage', currentPage || 0],
          ['lang', language],
          ['curr', currency],
          ['sort', sortCode || ''],
          ['query', query || ''],
          ['pageSize', 12],
        ];
        return this.httpService.get<BOProductSearchPage>(
          `${baseSite.uid}/categories/${categoryId}/products`,
          queryParams,
        );
      }),
    );
  }
}
